// extracted by mini-css-extract-plugin
export var displayNone = "_o7-6";
export var imgContainer = "_o7-2";
export var overflowHidden = "_o7-3";
export var productInfoCardButtonContainer = "_o7-5";
export var productTitleText = "_o7-4";
export var rightArrow = "_o7-1";
export var rightArrowContainer = "_o7-0";